module.exports = __webpack_public_path__ + "static/img/login_logo.238682a8.png";